import { InputAdornment, TextareaAutosize, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useSpeechRecognition } from "react-speech-recognition";
import SpeechToText from "./speechToText";

const TextFieldSpeech = (props) => {
  const { finalTranscript, transcript, listening } = useSpeechRecognition();
  const [isSelected, setIsSelected] = useState(false);
  const minRows = props.minRows || 2;
  useEffect(() => {
    if (finalTranscript && isSelected) {
      props.onChange(finalTranscript + " ", true, props.id);
      setIsSelected(false);
    }
  }, [finalTranscript]);

  return (
    <TextField
      {...props}
      onChange={(event) => {
        props.onChange(event.target.value, false, props.id);
      }}
      sx={{
        ...props.sx,
        ...(props.multiline ? {

        } : {}),
      }}
      InputProps={{
        inputComponent: TextareaAutosize,
        inputProps: {
          minRows: props.multiline ? minRows : undefined,
          maxRows: props.multiline ? minRows * 2 : undefined,
          style: props.multiline
            ? {
              resize: "vertical",
              overflowY: 'auto',
            }
            : {},
        },
        endAdornment: <InputAdornment position="end" sx={{ ml: 4 }}>
          <>
            <SpeechToText
              listening={listening && isSelected}
              setIsSelected={setIsSelected}
              transcript={transcript}
              disabled={props.disabled}
            />
          </>
        </InputAdornment>,
      }}

    />
  );
};

export default TextFieldSpeech;
